module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1004-dff7486943e1f8f8286182d1c26d9dcb.png";